export enum Category {
    GlutenFree = 'gluten-free'
}
